<template>
  <b-row no-gutters>
    <b-col cols="12">
      <label class="fs-18 font-weight-bold">
        <span v-if="isTerm">Texto sobre termos e condições</span>
        <span v-else>Texto sobre Privacidade</span>
      </label>
      <ckeditor
        v-model="text"
        :editor="editorSettings.type"
        :config="editorSettings.config"
      />
    </b-col>
    <b-col cols="12" class="my-4">
      <b-button variant="success" block @click="save()">
        <i class="fas fa-save mr-2"></i>
        Salvar
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import makeToast from '@/mixins/makeToast'
import UploadAdapter from '@/utils/UploadAdapterAxios.js'


const UploadAdapterPlugin = (editor) => {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    const token = localStorage.getItem('token');
    return new UploadAdapter(loader, token);
  };
};

export default {
  name: 'TermsAndPrivacy',
  mixins: [makeToast],

  props: {
    isTerm: {
      type: Boolean,
      default: false,
      required: true
    },
  },

  data() {
    return {
      loading: false,
      text: "",
      editorSettings: {
        type: ClassicEditor,
        config: {
          extraPlugins: [UploadAdapterPlugin],
          height:'50em',
        },
      },
    };
  },
  
  mounted() {
    this.get();
  },
  computed: {
    ...mapState(['dadosUsuario']),
  },

  methods: {
    ...mapActions('shopkeeper', ['saveTermsAndService', 'getCustomization']),
    
    get() {
      this.$store.dispatch('startLoader');
      this.loading = true;

      this.getCustomization(this.dadosUsuario.id)
        .then((response) => {
          if (!response.data.data) return;
          const { privacy_policy, terms_conditions } = response.data.data;
          this.text = this.isTerm ? terms_conditions : privacy_policy;
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    save() {
      const request = {
        userId: this.dadosUsuario.id,
        text: this.text, 
        isTerm: this.isTerm,
      };

      this.$store.dispatch('startLoader');
      this.loading = true;

      this.saveTermsAndService(request)
        .then(() => {
          this.makeToast(
            'Sucesso',
            'Informações salvas com sucesso',
            'success'
          );
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
  }
}
</script>